import { authAPIUrl } from "@/environment";
import { ArtService } from "@/services/art.service";

import { catched } from "./catched";

export class ArtHandler {
  constructor() {
    this.artServer = new ArtService(authAPIUrl);
  }

  createArt(name, teamIds = [], solutionTrainId, userIds) {
    const params = {
      name: name,
      team_ids: teamIds,
      solution_train_id: solutionTrainId,
      user_ids: userIds,
    };

    return this.artServer.createArt(params); // not catched -> error is exposed via FeedbackButton
  }

  updateArt(artId, name, teamIds, solutionTrainId, userIds) {
    const ignoreTrainId = solutionTrainId === undefined;
    const params = {
      name: name,
      team_ids: teamIds,
      ...(ignoreTrainId ? {} : { solution_train_id: solutionTrainId }),
      user_ids: userIds,
    };

    return this.artServer.updateArt(artId, params); // not catched -> error is exposed via FeedbackButton
  }

  getArt(artId) {
    return catched(this.artServer.getArt(artId));
  }

  getArts({ order } = {}) {
    return catched(this.artServer.getArts(order));
  }

  getMembers(id) {
    return catched(this.artServer.getMembers(id));
  }

  deleteArt(artId) {
    return catched(this.artServer.deleteArt(artId));
  }
}
